module.exports = __webpack_public_path__ + "img/fireworks1.b580d312.svg";